export enum ActionListType {
    Original = 'Original',
    PAL = 'Personalized'
}
